import { useCallback, useState } from 'react';
import { observable } from 'mobx';

export const useModalState = (initialState = false) => {
  const [state] = useState(() => observable.box(initialState));

  const show = useCallback(() => state.set(true), [state]);
  const hide = useCallback(() => state.set(false), [state]);

  return [state, { show, hide }] as const;
};
